import { AiOutlineDownload } from "@react-icons/all-files/ai/AiOutlineDownload";
import { GrDocumentUpload } from "@react-icons/all-files/gr/GrDocumentUpload";
import React, { createContext, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import * as XLSX from "xlsx";
import { getAllMembersForExportAction } from "../../Redux/Action/MemberAction";
import Auth from "../../Utilities/Auth";
import ButtonLoader from "../CommonComponent/ButtonLoader/ButtonLoader";
import CommonModal from "../CommonComponent/CommonModal/CommonModal";
import ComponentIdentifier from "../CommonComponent/ComponentHeader/ComponentIdentifier";
import HeaderComponent from "../CommonComponent/ComponentHeader/HeaderComponent";
import SectionLoader from "../CommonComponent/SectionLoader/SectionLoader";
import DonationComponent from "./MemberSubComponent/DonationComponent";
import IdCar from "./MemberSubComponent/id.Car";
import ImportMemberForm from "./MemberSubComponent/ImportMemberForm";
import MemberForm from "./MemberSubComponent/MemberForm";
import MemberTable from "./MemberSubComponent/MemberTable";
import { ToastContainer } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import { TiDelete } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import CommonSearch from "../CommonComponent/CommonSearch/CommonSearch";

export const MemberContext = createContext();

function AllMemberComponent(props) {
  // let data from auth
  let agentDetail = JSON.parse(Auth.header().userdetail || "{}");
  //Hook
  const allMemberTableLoaderRef = useRef();
  const dispatch = useDispatch();
  const membersExportRef = useRef();

  //State
  const [allMemberReload, setAllMemberReload] = useState(false);
  const [filteredMemberData, setFilteredMemberData] = useState([]);
  const [addMemberModelShow, setAddMemberModelShow] = useState(false);
  const [editMemberModelShow, setEditMemberModelShow] = useState(false);
  const [getSingleMemberData, setGetSingleMemberData] = useState({});
  const [donationModelShow, setDonationModelShow] = useState(false);
  const [yearForPayment, setYearForPayment] = useState([]);
  const [memberIdCardModelShow, setMemberIdCardModelShow] = useState(false);
  const [idData, setIdData] = useState({});
  const [searchedKey, setSearchedKey] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [importMemberModal, setImportMemberModal] = useState(false);
  const [member_barcode, setMember_barcode] = useState("");
  const [agent_id, setAgent_id] = useState(JSON.parse(Auth.header().userdetail || "{}")?.is_admin == "1" ? "" : JSON.parse(Auth.header().userdetail || "{}")?.id)
  const [organization, setOrganization] = useState({});
  const [dataForTable, setDataForTable] = useState({});

  // data getting from store
  const allMember = useSelector((state) => state.memberSlice.allMember);

  // reset necessary state
  useEffect(() => {
    if (!addMemberModelShow && !donationModelShow && !editMemberModelShow) {
      setGetSingleMemberData({});
    }
  }, [addMemberModelShow, donationModelShow, editMemberModelShow]);


  // reset organization when donation modal close
  useEffect(() => {
    if (donationModelShow == false) {
      setOrganization({})
    }
  }, [donationModelShow])

  // reset single member when update and donation modal close
  useEffect(() => {
    if (editMemberModelShow == false && donationModelShow == false) {
      setGetSingleMemberData({});
    }
  }, [editMemberModelShow, donationModelShow]);

  // export on click
  const exportOnClick = () => {
    // making payload for export members
    const payload = {
      data: { search_key: searchedKey, member_barcode, agent_id: agent_id },
      membersExportRef,
    };
    // action dipsatch
    dispatch(getAllMembersForExportAction(payload));
  };

  // download excel for add agent
  const downloadExcelForAddMember = () => {
    let userDetail = JSON.parse(Auth.header().userdetail || "{}");
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet([
      {
        member_name: "",
        guardian: "",
        grade: "",
        mobile: "",
        whats_app: "",
        state: "",
        district: "",
        police_station: "",
        area_type: "",
        post_office: "",
        village: "",
        place: "",
        pincode: "",
        neighborhood: "",
        city: "",
      },
    ]);
    XLSX.utils.book_append_sheet(wb, ws, "import sheet");
    XLSX.writeFile(wb, "memberImportSheet.xlsx");
  };

  return (
    <>
      <MemberContext.Provider
        value={{
          setAllMemberReload,
          setFilteredMemberData,
          setAddMemberModelShow,
          setEditMemberModelShow,
          setGetSingleMemberData,
          getSingleMemberData,
          setDonationModelShow,
          yearForPayment,
          setYearForPayment,
          memberIdCardModelShow,
          setMemberIdCardModelShow,
          idData,
          setIdData,
          setSearchedKey,
          searchedKey,
          donationModelShow,
          allMemberReload,
          currentPage,
          setCurrentPage,
          setImportMemberModal,
          member_barcode,
          organization,
          agent_id,
          setOrganization,
          dataForTable,
          setDataForTable
        }}
      >
        <Row>

          <Col lg={12} md={12} sm={12} >
            <Card>
              <Card.Header className="d-flex align-items-center justify-content-between">
                <ComponentIdentifier link_name={"Donor List"} component_name={""} />
                <div className="d-flex align-items-center justify-content-between">
                  {HeaderComponent.refresh([setAllMemberReload])}
                  {HeaderComponent.add(setAddMemberModelShow)}
                </div>
              </Card.Header>
              <Card.Body>
                <div className="position-relative">
                  <Row>
                    <Col
                      lg={3}
                      md={3}
                      sm={12}
                      className="searchArea d-flex align-items-center mb-2"
                    >
                      {/*agent search key*/}

                      {/* <span style={{ position: "relative", width: "100%", display: "block" }}>
                        <Form.Control

                          onChange={(e) => setSearchedKey(e.target.value)}
                          id={"searchedKey"}
                          type="text"
                          placeholder={"Search Name / Village / Phone No."}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // stop form submit if needed
                              setAllMemberReload((prev) => !prev);
                            }
                          }}
                        />

                        <RxCross2 onClick={e => {
                          setSearchedKey("")
                          document.getElementById("searchedKey").value = ""
                          setAllMemberReload((prev) => !prev);
                        }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                      </span> */}

                      <CommonSearch
                        preFilterData={dataForTable.data || []}
                        setFilteredDataState={setFilteredMemberData}
                        placeHolder={"Search Name / Village / Phone No."}
                        propertyForMatch={["member_name", "village", "mobile"]}
                      />

                      {/*agent search by id/b-code*/}
                      {/* <Form.Group className={""} controlId="formBasicEmail">
                        <Form.Control
                          onChange={(e) => setMember_barcode(e.target.value)}
                          className="ms-2"
                          type="text"
                          style={{ width: "80px" }}
                          placeholder={"b-code"}
                        />
                      </Form.Group> */}


                    </Col>
                    <Col
                      lg={2}
                      md={2}
                      sm={12}
                      className="searchArea d-flex align-items-center mb-2"
                    >
                      {/*member search by agent id*/}
                      {JSON.parse(Auth.header().userdetail || "{}")?.is_admin == "1" && <>
                        <Form.Group className={""} controlId="formBasicEmail">
                          <span style={{ position: "relative", width: "100%", display: "block" }}>
                            <Form.Control
                              id="memberFilterCollectorIdField"
                              onChange={(e) => {
                                setAgent_id(e.target.value)
                                setAllMemberReload(prev => !prev)
                              }}
                              className="ms-2"
                              type="text"
                              style={{ width: "150px" }}
                              placeholder={"Collector ID"}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault(); // stop form submit if needed
                                  setAllMemberReload((prev) => !prev);
                                }
                              }}
                            />
                            <RxCross2 onClick={e => {
                              setAgent_id("")
                              document.getElementById("memberFilterCollectorIdField").value = ""
                              setAllMemberReload((prev) => !prev);
                            }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                          </span>
                        </Form.Group>

                        <Button
                          className="ms-2 btn-sm"
                          onClick={(e) => {
                            setCurrentPage(1);
                            setAllMemberReload((prev) => !prev);
                          }}
                        >
                          Search
                        </Button>
                      </>}

                    </Col>
                    {agentDetail.is_admin == 1 && (
                      <Col lg={7} md={7} sm={12} className="mt-1 mb-2 text-lg-end text-center">
                        {/* <Button
                          className="me-2 btn-sm"
                          variant="success"
                          onClick={(e) => downloadExcelForAddMember()}
                        >
                          <AiOutlineDownload /> Download Excel
                        </Button> */}
                        <Button
                          ref={membersExportRef}
                          className="me-2 btn-sm"
                          variant="info"
                          onClick={(e) => exportOnClick()}
                        >
                          <AiOutlineDownload />
                          Download
                          <ButtonLoader />
                        </Button>

                        <Button
                          className="btn-sm"
                          variant="primary"
                          onClick={(e) => setImportMemberModal(true)}
                        >
                          <GrDocumentUpload />
                          Upload
                        </Button>
                      </Col>
                    )}
                  </Row>
                  <MemberTable data={filteredMemberData} />
                  {/* <SectionLoader loading_handle_ref={allMemberTableLoaderRef} /> */}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/*add member modal show*/}
        <CommonModal
          show={addMemberModelShow}
          setShow={setAddMemberModelShow}
          title={"Add Donor"}
          size="lg"
        >
          <MemberForm />
        </CommonModal>

        {/*edit member modal show*/}
        <CommonModal
          show={editMemberModelShow}
          setShow={setEditMemberModelShow}
          title={"Edit Donor"}
          size="lg"
        >
          <MemberForm formType={'Update'} />
        </CommonModal>

        {/*Donation collection modal show*/}
        <CommonModal
          show={donationModelShow}
          setShow={setDonationModelShow}
          title={getSingleMemberData.member_name}
          size="md"
        >
          <DonationComponent />
        </CommonModal>

        {/*Donation collection modal show*/}
        {/* <CommonModal
          show={memberIdCardModelShow}
          setShow={setMemberIdCardModelShow}
          title={"Id Card"}
          size="lg"
        >
          <IdCar />
        </CommonModal> */}

        {/*import member modal*/}
        <CommonModal
          show={importMemberModal}
          setShow={setImportMemberModal}
          title={"Import member"}
          size="md"
        >
          <ImportMemberForm />
        </CommonModal>

        <ToastContainer />
      </MemberContext.Provider>
    </>
  );
}

export default AllMemberComponent;
